;
define("facets_item_list_sort_selector.tpl", function(){});

